import { format } from 'date-fns'

import styles from './styles.module.scss'

import { CalendarProps } from './types'

export const Calendar = ({ date }: CalendarProps) => (
  <div className={styles.calendar}>
    <div className={styles.month}>{format(date, 'MMM')}</div>
    <div className={styles.day}>{format(date, 'dd')}</div>
  </div>
)
